// Barra de configurações da página de Bairros — CEP Único + Pedido Mínimo
// lado a lado numa faixa compacta (substitui os dois cards empilhados).

import { Check, MapPin, ShoppingCart } from "lucide-react";
import { Button } from "../../../components/ui/button";
import { InputDecimal } from "../../../components/ui/input-decimal";
import { Switch } from "../../../components/ui/switch";
import { formatCep } from "../lib/cep";

export default function ConfigBar({
  cepUnico,
  cepUnicoValue,
  onCepSwitchChange,
  pedidoMinimoValor,
  pedidoMinimoSaving,
  pedidoMinimoTouched,
  onPedidoMinimoChange,
  onPedidoMinimoSalvar,
}) {
  const pmNum = parseFloat(String(pedidoMinimoValor).replace(",", ".")) || 0;
  const pmAtivo = pmNum > 0;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
      {/* CEP Único */}
      <div
        className={`rounded-xl border p-3 transition-colors ${
          cepUnico ? "bg-primary/5 border-primary/30" : "bg-card"
        }`}
      >
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-3 min-w-0">
            <div
              className={`w-9 h-9 rounded-lg flex items-center justify-center shrink-0 ${
                cepUnico ? "bg-primary/20 text-primary" : "bg-muted text-muted-foreground"
              }`}
            >
              <MapPin className="w-4 h-4" />
            </div>
            <div className="min-w-0">
              <h3 className="font-semibold text-sm flex items-center gap-1.5">
                CEP Único
                {cepUnico && <Check className="w-3.5 h-3.5 text-green-500" />}
              </h3>
              <p className="text-xs text-muted-foreground truncate">
                {cepUnico ? (
                  <span className="text-primary font-medium">
                    Todos os bairros usam {formatCep(cepUnicoValue)}
                  </span>
                ) : (
                  "Cada bairro pode ter seu próprio CEP"
                )}
              </p>
            </div>
          </div>
          <Switch checked={cepUnico} onCheckedChange={onCepSwitchChange} />
        </div>
      </div>

      {/* Pedido Mínimo */}
      <div
        className={`rounded-xl border p-3 transition-colors ${
          pmAtivo ? "bg-emerald-500/5 border-emerald-500/30" : "bg-card"
        }`}
      >
        <div className="flex items-center justify-between gap-3 flex-wrap sm:flex-nowrap">
          <div className="flex items-center gap-3 min-w-0">
            <div
              className={`w-9 h-9 rounded-lg flex items-center justify-center shrink-0 ${
                pmAtivo
                  ? "bg-emerald-500/20 text-emerald-600 dark:text-emerald-400"
                  : "bg-muted text-muted-foreground"
              }`}
            >
              <ShoppingCart className="w-4 h-4" />
            </div>
            <div className="min-w-0">
              <h3 className="font-semibold text-sm flex items-center gap-1.5">
                Pedido Mínimo
                {pmAtivo && <Check className="w-3.5 h-3.5 text-emerald-500" />}
              </h3>
              <p
                className="text-xs text-muted-foreground truncate"
                title="Afeta apenas pedidos de entrega feitos pelo módulo Cardápio. Abaixo do mínimo, o cliente vê um aviso de 'Faltam R$ X,XX'."
              >
                {pmAtivo ? (
                  <span className="text-emerald-600 dark:text-emerald-400 font-medium">
                    Entregas a partir de R$ {pmNum.toFixed(2).replace(".", ",")}
                  </span>
                ) : (
                  "Entrega liberada para qualquer valor"
                )}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <div className="relative">
              <span className="absolute left-2.5 top-1/2 -translate-y-1/2 text-xs text-muted-foreground z-10 pointer-events-none">
                R$
              </span>
              {/* Caixa registradora (dono, 26/10/2026): 0,00 = sem pedido mínimo */}
              <InputDecimal
                data-e2e="bairros-pedido-minimo"
                decimals={2}
                value={pedidoMinimoValor}
                onChange={onPedidoMinimoChange}
                className="pl-8 w-28 h-9 text-sm"
              />
            </div>
            <Button
              size="sm"
              onClick={onPedidoMinimoSalvar}
              disabled={pedidoMinimoSaving || !pedidoMinimoTouched}
              className="h-9"
            >
              {pedidoMinimoSaving ? "Salvando..." : "Salvar"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
